import React, { useEffect, useState } from 'react';
import Button from '../../../components/elements/button';
import Icon from '../../../components/icons';
import { useChecklistApi } from '../../../store/api/hooks/checklistApiHook';
import { useParams } from 'react-router-dom';
import { co } from '@fullcalendar/core/internal-common';

interface Props {
    _ref: React.RefObject<HTMLDialogElement>
    cards: any[]
}

const ChecklistPreviewModal: React.FC<Props> = ({ _ref, cards }) => {
    const [isOpen, setIsOpen] = useState<boolean>(false);
    const checklistAPI: any = useChecklistApi();
    const [rowData, setRowData] = useState<any[]>([]);
     const params: any = useParams();
    const colse = (e: any) => {
        e.preventDefault();
        e.stopPropagation();
        _ref?.current?.close()
    }

    const EditableText = (text: string, onInput: (e: any) => void) => {
        return <p className='outline-none text-[0.9rem] focus:bg-slate-200 leading-6'>{text}</p>;
    }

    const getFormComponent = (card: any) => {
        switch (card.type) {
            case 'checkbox':
                return <div>
                    {EditableText(card.label, (e: any) => {
                        card.label = e.target.innerText;
                    })}

                    <div className={`flex gap-4 mt-2 ${card.customize ? 'flex-col items-start' : ''}`}>
                        {card.options.map((option: string, index: number) => (
                            <div className='flex gap-2' key={`${card.id}-${index}`}>
                                <input type="checkbox" name={`${card.id}`} value={option} />
                                {card.optionEditable ?
                                    EditableText(option, (e: any) => {
                                        card.options[index] = e.target.innerText;
                                    })
                                    : <p>{option}</p>}

                            </div>
                        ))}

                    </div>
                </div>;
            case 'text':
                return <div>
                    {EditableText(card.label, (e: any) => {
                        card.label = e.target.innerText;
                    })}

                    <input type="text" name={`${card.id}`} placeholder="Enter text"
                        className='border-[#CECECE] border focus:outline-none focus:primary text-[0.938rem] mt-2 pl-2 py-1 font-xs h-[2rem] w-full' />
                </div>
            case 'radio':
                return <div>
                    {EditableText(card.label, (e: any) => {
                        card.label = e.target.innerText;
                    })}
                    <div className={`flex gap-4 mt-2 ${card.customize ? 'flex-col items-start' : ''}`}>
                        {card.options.map((option: string, index: number) => (
                            <div className='flex gap-2' key={`${card.id}-${index}`}>
                                <input type="radio" name={`${card.id}`} value={option} />
                                {card.optionEditable ?
                                    EditableText(option, (e: any) => {
                                        card.options[index] = e.target.innerText;

                                    })
                                    : <p>{option}</p>}

                            </div>
                        ))}

                    </div>
                </div>
            case 'number':
                return <div>
                    {EditableText(card.label, (e: any) => {
                        card.label = e.target.innerText;
                    })}
                    {card.component === 'amount' ? <div className='flex items-center gap-2'>
                        <span>$</span><input type="number" name={`${card.id}`} placeholder="Enter Amount" className='border-[#CECECE] border focus:outline-none focus:primary text-[0.938rem] mt-2 pl-2 py-1 font-xs h-[2rem] w-full' />
                    </div>
                        : <input type="number" name={`${card.id}`} placeholder="Enter number" className='border-[#CECECE] border focus:outline-none focus:primary text-[0.938rem] mt-2 pl-2 py-1 font-xs h-[2rem] w-full' />
                    }
                </div>
            case 'file':
                return <div>
                    {EditableText(card.label, (e: any) => {
                        card.label = e.target.innerText;
                    })}
                    <input type="file" name={`${card.id}`} accept="image/*" multiple={card.multiple} />
                </div>
            case 'signature':
                return <div>
                    {EditableText(card.label, (e: any) => {
                        card.label = e.target.innerText;
                    })}
                    <div className='mt-2 border-[#CECECE] border h-[80px] p-3 text-center ' >
                        Assignee will sign here
                    </div>
                </div>
            case 'date':
                return <div>
                    {EditableText(card.label, (e: any) => {
                        card.label = e.target.innerText;
                    })}
                    <div className='flex gap-2 mt-2'>
                        <input type="date" name={`${card.id}`} className='border-[#CECECE] border focus:outline-none focus:primary text-[0.938rem] pl-2 py-1 font-xs h-[2rem] w-full' />
                    </div>
                </div>;
            case 'time':
                return <div>
                    {EditableText(card.label, (e: any) => {
                        card.label = e.target.innerText;
                    })}
                    <div className='flex gap-2 mt-2'>
                        <input type="time" name={`${card.id}`} className='border-[#CECECE] border focus:outline-none focus:primary text-[0.938rem] pl-2 py-1 font-xs h-[2rem] w-full' />
                    </div>
                </div>;
            default:
                return null;
        }
    };
  const getChecklists = () => {
   
    let payload: any = {
     
      
    };
   
      payload.checkListIDs=params.id;
    
   
    checklistAPI.getChecklists(
      payload,
      (data: any) => {
        console.log("Checklist Data", data);
        setRowData(data.checklistList ? data.checklistList : []);
      
        //setTotalRecords(data.totalRecord);
      },
      (error: any) => {
      
      }
    );
  };

    useEffect(() => {
        if (_ref.current) {
            const modal: any = _ref.current;
            const observer = new MutationObserver((mutations) => {
                for (const mutation of mutations) {
                    if (
                        mutation.type === "attributes" &&
                        mutation.attributeName === "open"
                    ) {

                        if (_ref.current?.hasAttribute("open")) {
                            setIsOpen(true);
                            getChecklists();
                        } else {
                            setIsOpen(false);
                        }
                    }
                }
            });
            if (modal) observer.observe(modal, { attributes: true });
            return () => observer.disconnect();
        }
    }, [_ref]);

    return (
        <dialog ref={_ref} className="modal">
            <div className="modal-box max-w-[90%] w-[50rem] h-[90vh] max-h-[90vh] p-0 flex flex-col">
                {/* Sticky Header */}
                <div className="sticky top-0 bg-white px-4 py-3 border-b border-gray-300 z-10 flex justify-between items-center">
                    <h2 className="text-lg font-semibold text-gray-800">{rowData[0]?.title}</h2>
                    <button onClick={colse}>
                        <Icon name="cross" className="w-5 h-5 text-gray-600 hover:text-black" />
                    </button>
                </div>

                {/* Scrollable Content */}
                <div className="px-4 py-4 overflow-y-auto flex-1">
                    {cards?.length > 0 ? (
                        cards.map((card: any, index: number) => (
                            <div key={index} className="mb-4">
                                {getFormComponent(card)}
                                {card.description && (
                                    <p className="text-xs text-[#8D6E63] mt-1">{card.description}</p>
                                )}
                            </div>
                        ))
                    ) : (
                        <div className="text-center text-lg font-semibold text-[#8D6E63]">No Checklist Found</div>
                    )}
                </div>

                {/* Footer sticks to bottom */}
                <div className="bg-white px-4 py-3 border-t border-gray-300 z-10 flex justify-end">
                    <Button type="button" theme="secondary" onClick={colse}>Cancel</Button>
                </div>
            </div>

            <form method="dialog" className="modal-backdrop" onClick={colse}></form>
        </dialog>
    );
};

export default ChecklistPreviewModal;